/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreatePromptTemplateForm,
  CreatePromptTemplateForm$Outbound,
  CreatePromptTemplateForm$outboundSchema,
} from "../components/createprompttemplateform.js";

export type CreateTemplateSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateTemplateSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateTemplateSecurity = {
  option1?: CreateTemplateSecurityOption1 | undefined;
  option2?: CreateTemplateSecurityOption2 | undefined;
};

export type CreateTemplateRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createPromptTemplateForm: CreatePromptTemplateForm;
};

/** @internal */
export type CreateTemplateSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateTemplateSecurityOption1$outboundSchema: z.ZodMiniType<
  CreateTemplateSecurityOption1$Outbound,
  CreateTemplateSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createTemplateSecurityOption1ToJSON(
  createTemplateSecurityOption1: CreateTemplateSecurityOption1,
): string {
  return JSON.stringify(
    CreateTemplateSecurityOption1$outboundSchema.parse(
      createTemplateSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateTemplateSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateTemplateSecurityOption2$outboundSchema: z.ZodMiniType<
  CreateTemplateSecurityOption2$Outbound,
  CreateTemplateSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createTemplateSecurityOption2ToJSON(
  createTemplateSecurityOption2: CreateTemplateSecurityOption2,
): string {
  return JSON.stringify(
    CreateTemplateSecurityOption2$outboundSchema.parse(
      createTemplateSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateTemplateSecurity$Outbound = {
  Option1?: CreateTemplateSecurityOption1$Outbound | undefined;
  Option2?: CreateTemplateSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateTemplateSecurity$outboundSchema: z.ZodMiniType<
  CreateTemplateSecurity$Outbound,
  CreateTemplateSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateTemplateSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateTemplateSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createTemplateSecurityToJSON(
  createTemplateSecurity: CreateTemplateSecurity,
): string {
  return JSON.stringify(
    CreateTemplateSecurity$outboundSchema.parse(createTemplateSecurity),
  );
}

/** @internal */
export type CreateTemplateRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreatePromptTemplateForm: CreatePromptTemplateForm$Outbound;
};

/** @internal */
export const CreateTemplateRequest$outboundSchema: z.ZodMiniType<
  CreateTemplateRequest$Outbound,
  CreateTemplateRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createPromptTemplateForm: CreatePromptTemplateForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      createPromptTemplateForm: "CreatePromptTemplateForm",
    });
  }),
);

export function createTemplateRequestToJSON(
  createTemplateRequest: CreateTemplateRequest,
): string {
  return JSON.stringify(
    CreateTemplateRequest$outboundSchema.parse(createTemplateRequest),
  );
}
